import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/react-hooks";
import client from "./utils/apolloClient";
import "./index.css";
import App from "./App";

createRoot(document.getElementById("root")).render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
);
